<template>
  <div class="panel">
    <h2>Загрузка GPX</h2>
    <div class="form-field">
      <label for="gpx-file">GPX-файл</label>
      <input id="gpx-file" type="file" accept=".gpx,application/gpx+xml" @change="onFileChange" />
    </div>
    <p v-if="error" class="error-message">{{ error }}</p>
    <button class="btn" :disabled="!file || uploading" @click="upload">
      {{ uploading ? 'Загрузка...' : 'Загрузить' }}
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { uploadGpx } from '../api/tracks'

const props = defineProps({
  metadata: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['uploaded'])

const file = ref(null)
const uploading = ref(false)
const error = ref('')

function onFileChange(event) {
  file.value = event.target.files[0] || null
  error.value = ''
}

async function upload() {
  if (!file.value) return
  if (!props.metadata.name?.trim()) {
    error.value = 'Укажите название трека'
    return
  }

  uploading.value = true
  error.value = ''

  try {
    const { data } = await uploadGpx(file.value, props.metadata)
    emit('uploaded', data)
    file.value = null
  } catch (err) {
    error.value = err.response?.data?.error || 'Не удалось загрузить GPX'
  } finally {
    uploading.value = false
  }
}
</script>
